module.exports = __webpack_public_path__ + "img/ssa_logo.6e7c429e.png";